import React from 'react';
import {
    Card,
    CardFooter,
    Table,
    Container,
    Row
} from 'reactstrap';
import RowData from './RowData';
import TablePagination from 'commonComponents/TablePagination';

const TableRoot = ({
    header,
    tableData,
    handleEdit,
    handleDelete,
    handleView,
    currentPage,
    totalPages,
    handlePageChange,
    rowsPerPage,
    setRowsPerPage
}) => {
    return (
        <Container fluid>
            <Row>
                <div className="col">
                    <Card className="shadow">
                        <Table className="align-items-center table-flush" responsive>
                            <thead className="thead-light">
                                <tr>
                                    {header.map((item, index) => (
                                        <th scope="col" key={index} className="align-items-center text-center">
                                            {item}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            {tableData && tableData.length > 0 ? (
                                tableData.map((item, index) => (
                                    <RowData
                                        key={item.id || index}
                                        itemInfo={item}
                                        index={index}
                                        handleEdit={handleEdit}
                                        handleDelete={handleDelete}
                                        handleView={handleView}
                                        currentPage={currentPage}
                                        rowsPerPage={rowsPerPage}
                                    />
                                ))
                            ) : (
                                <tbody>
                                    <tr>
                                        <td colSpan={header.length} className="text-center py-4">
                                            No regions found
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </Table>

                        <CardFooter className="py-4">
                            <TablePagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                handlePageChange={handlePageChange}
                                rowsPerPage={rowsPerPage}
                                setRowsPerPage={setRowsPerPage}
                            />
                        </CardFooter>
                    </Card>
                </div>
            </Row>
        </Container>
    );
};

export default TableRoot;
